// CLAUDE-SYNC: Replaced MOCK with real API calls (2026-05-20)
// Photo upload was returning null URLs — wired to real multipart POST
// Photos stored via StorageController → S3 or local per environment config

import axios from '../axios';
import { BASE_URL } from '../Utils';

const STOPS_URL = BASE_URL + '/stops';

/**
 * Get all photos for a stop from the stop's photos array
 * The stop response includes: photos: [{ userId, photoType, fileKey }]
 * Use getPhotoUrl(photo.fileKey) to get the displayable URL
 */

export function uploadStopPhoto(stopId, photoType, photoFile) {
  const formData = new FormData();
  formData.append('photoType', photoType);
  formData.append('photo', photoFile);
  return axios({
    url: `${STOPS_URL}/${stopId}/photo`,
    method: 'put',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

/**
 * GET /api/stops/:stopId/photos
 * → Returns array of { photoId, url, label, timestamp } for lightbox display
 */
export function getStopPhotos(stopId) {
  return axios({
    url: `${STOPS_URL}/${stopId}/photos`,
    method: 'get',
  });
}

export function uploadPhotoNotes(stopId, data) {
  return axios({
    url: `${STOPS_URL}/${stopId}/photo-notes`,
    method: 'put',
    data
  });
}